import React, { useState, useEffect } from 'react';
import { TechArea, skillColor, myBG } from '../helper/constants';
import TechLayout from './TechLayout';
import TypeBox from '../helper/TypeBox';
import FilterBox from '../helper/FilterBox';

const TechSkills = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  const uniqueCategories = [
    ...new Set(TechArea.flatMap((tech) => tech.category)),
  ];

  const uniqueTypes = [...new Set(TechArea.map((tech) => tech.type))];

  const handleCategoryClick = (category) => {
    setActiveCategory(category);
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const isMobile = windowWidth <= 768;

  return (
    <section section id='tech-skills' style={styles.containerSection}>
      <h2>Tech Skills</h2>
      {/* <div style={styles.container}></div> */}
      {/* <div style={styles.notationText}>
        <span style={styles.circle}></span> - chosen filter
      </div> */}
      {isMobile ? (
        <div>
          <div style={styles.filterBox}>
            {/* <FilterBox /> */}
            <FilterBox
              activeCategory={activeCategory}
              setActiveCategory={setActiveCategory}
              uniqueCategories={uniqueCategories}
              handleCategoryClick={handleCategoryClick}
            />
          </div>

          {/* Render the skill boxes for unique types */}
          <div style={styles.typeBoxes}>
            {uniqueTypes.map((type) => (
              <div style={styles.typeBox}>
                <TypeBox key={type} type={type} category={activeCategory} />
              </div>
            ))}
          </div>

          {/* <div style={styles.filterBox}>
            <FilterBox
              activeCategory={activeCategory}
              setActiveCategory={setActiveCategory}
              uniqueCategories={uniqueCategories}
              handleCategoryClick={handleCategoryClick}
            />
          </div> */}
        </div>
      ) : (
        <TechLayout
          activeCategory={activeCategory}
          setActiveCategory={setActiveCategory}
          uniqueCategories={uniqueCategories}
          handleCategoryClick={handleCategoryClick}
        />
      )}
      {/* <div style={styles.notationText}>
        <span style={styles.circle}></span> - chosen filter
      </div> */}
    </section>
  );
};

const styles = {
  containerSection: {
    // backgroundColor: myBG,
    // marginTop: '10px',
    marginLeft: '5px',
    marginBottom: '10px',
    marginRight: '5px',
    padding: '20px', // Add some padding to create space around the content
    // background: 'rgba(255, 255, 255, 0.2)', // Use an rgba color for the background with reduced opacity
    background: myBG,
    backdropFilter: 'blur(10px)', // Add a blur effect to create the glass panel effect
    borderRadius: '10px', // Add rounded corners for a better look
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)', // Add a subtle shadow for depth
  },
  filterButton: {
    marginRight: '8px',
    padding: '4px 8px',
    borderRadius: '4px',
    backgroundColor: '#eee',
    cursor: 'pointer',
  },
  activeFilterButton: {
    backgroundColor: '#ccc',
  },
  typeBoxHeading: {
    textAlign: 'center',
    padding: '5px',
  },
  // container: {
  //   display: 'grid',
  //   gridTemplateColumns: '1fr 1fr 1fr', // Divide the layout into 3 equal columns
  //   gridTemplateRows: 'auto auto auto', // Allow automatic height for rows
  //   gap: '16px', // Add some gap between elements
  // },
  filterBox: {
    // gridColumn: '2 / 3', // Position the filter box in the second column
    // gridRow: '2 / 3', // Position the filter box in the second row
    padding: '5px',
    // border: '2px solid black',
    display: 'flex',
    justifyContent: 'center', // Center the content horizontally
    alignItems: 'center', // Center the content vertically
    flexWrap: 'wrap', // Wrap items to the next line if needed
    // backgroundColor: '#f7f7f7',
    // background: 'linear-gradient(45deg, #f7f7f7, #e6e6e6)',
    // background: `linear-gradient(45deg, #C13584, #8134AF),
    //              linear-gradient(135deg, #8134AF, #405DE6),
    //              linear-gradient(225deg, #405DE6, #5851DB),
    //              linear-gradient(315deg, #5851DB, #C13584)`,
    // backgroundSize: '50% 50%, 50% 50%, 50% 50%, 50% 50%',
    // backgroundRepeat: 'no-repeat',
    background: 'linear-gradient(45deg, #C13584, #8134AF, #405DE6, #5851DB)',
    borderRadius: '10px',
    margin: '5px',
  },
  typeBoxes: {
    // gridColumn: '1 / 4', // Extend the type boxes across all columns
    // gridRow: '1 / 2', // Position the type boxes in the first row
    // display: 'grid',
    // gridTemplateColumns: '1fr 1fr 1fr', // Divide the type boxes into 3 equal columns
    gap: '16px', // Add some gap between type boxes
    justifyContent: 'space-between', // Distribute the type boxes evenly horizontally
    alignItems: 'center', // Center the type boxes vertically
    // border: '2px solid black',
  },
  typeBox: {
    // padding: '16px',
    // border: '2px solid black',
    // borderRadius: '4px',
    backgroundColor: '#f7f7f7',
    borderRadius: '10px',
    margin: '5px',
  },
  notationText: {
    color: skillColor,
    fontStyle: 'italic',
    fontSize: '14px',
    fontWeight: 'bold',
  },
  circle: {
    display: 'inline-block',
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    backgroundColor: skillColor, // Replace skillColor with the desired color value
    marginRight: '5px',
  },
};

export default TechSkills;
